import * as Yup from "yup";

// Default reasons shown as checkboxes (falls back if master data / companyRegulationOptions is empty)

export const DEFAULT_WARNING_LETTER_REASONS = [
  { id: "LACK_OF_RESPONSIBILITY", label: "warning_letter.reason.lack_of_responsibility" },
  { id: "VIOLATE_COMPANY_RULE", label: "warning_letter.reason.violate_company_rule" },
  { id: "NOT_STANDARD_WORK", label: "warning_letter.reason.not_standard_work" },
  { id: "PROPERTY_DAMAGE", label: "warning_letter.reason.property_damage" },
  { id: "GAMBLING", label: "warning_letter.reason.gambling" },
  { id: "ABANDON_DUTY", label: "warning_letter.reason.abandon_duty" },
  { id: "ABSENT_NO_NOTICE", label: "warning_letter.reason.absent_no_notice" },
  { id: "FIGHTING", label: "warning_letter.reason.fighting" },
  { id: "WEAPON_IN_AREA", label: "warning_letter.reason.weapon_in_area" },
  { id: "LATE_REGULARLY", label: "warning_letter.reason.late_regularly" },
  { id: "DRUGS", label: "warning_letter.reason.drugs" },
  { id: "INCITE_VIOLATION", label: "warning_letter.reason.incite_violation" },
  { id: "DISOBEY_SUPERIOR", label: "warning_letter.reason.disobey_superior" },
];

export const OTHER_REASON_ID = "OTHER";

const schema = Yup.object().shape({
  employeeId: Yup.string().required("กรุณาเลือกพนักงาน"),
  position: Yup.string().nullable(),
  incidentStartDate: Yup.string().required("กรุณาระบุวันที่เริ่มเหตุการณ์"),
  incidentEndDate: Yup.string().required("กรุณาระบุวันที่สิ้นสุดเหตุการณ์"),
  issueDate: Yup.string().required("กรุณาระบุวันที่ออกหนังสือเตือน"),

  // "subject" now uses companyRegulationOptions (master data passed in as a prop),
  // not a hardcoded option list.
  subject: Yup.string().required("กรุณาเลือกเรื่องหนังสือเตือน"),

  reasons: Yup.array()
    .of(Yup.string())
    .min(1, "กรุณาเลือกเหตุผลอย่างน้อย 1 ข้อ"),

  otherReasonDetail: Yup.string().when("reasons", {
    is: (reasons = []) => reasons.includes(OTHER_REASON_ID),
    then: (s) => s.required("กรุณาระบุรายละเอียดเหตุผลอื่นๆ"),
  }),

  incidentDetail: Yup.string()
    .max(300, "กรอกได้ไม่เกิน 300 ตัวอักษร"),
  // .required("กรุณาระบุรายละเอียดการกระทำ / ข้อเท็จจริง"),

  authorizedSigner: Yup.object().shape({
    employeeId: Yup.string().required("กรุณาเลือกผู้ลงนาม"),
    position: Yup.string().nullable(),
    signDate: Yup.string().required("กรุณาระบุวันที่ลงนาม"),
    useIssueDateAsSignDate: Yup.boolean(),
  }),

  supervisor: Yup.object().shape({
    employeeId: Yup.string().when("unspecified", {
      is: false,
      then: (s) => s.required("กรุณาเลือกพนักงาน"),
      otherwise: (s) => s.nullable(),
    }),
    position: Yup.string().nullable(),
    signDate: Yup.string().when("unspecified", {
      is: false,
      then: (s) => s.required("กรุณาระบุวันที่ลงนาม"),
      otherwise: (s) => s.nullable(),
    }),
    unspecified: Yup.boolean(),
  }),

  witness: Yup.object().shape({
    employeeId: Yup.string().when("unspecified", {
      is: false,
      then: (s) => s.required("กรุณาเลือกพนักงาน"),
      otherwise: (s) => s.nullable(),
    }),
    position: Yup.string().nullable(),
    signDate: Yup.string().when("unspecified", {
      is: false,
      then: (s) => s.required("กรุณาระบุวันที่ลงนาม"),
      otherwise: (s) => s.nullable(),
    }),
    unspecified: Yup.boolean(),
  }),

  acknowledgedEmployee: Yup.object().shape({
    receivedDate: Yup.string().nullable(),
    notSignedYet: Yup.boolean(),
  }),
});

export const initialValues = {
  employeeId: undefined,
  position: "",
  incidentStartDate: "",
  incidentEndDate: "",
  issueDate: "",
  subject: undefined,
  reasons: [],
  otherReasonDetail: "",
  incidentDetail: "",

  authorizedSigner: {
    employeeId: undefined,
    position: "",
    signDate: "",
    useIssueDateAsSignDate: false,
  },

  supervisor: {
    employeeId: undefined,
    position: "",
    signDate: "",
    unspecified: false,
  },
  witness: {
    employeeId: undefined,
    position: "",
    signDate: "",
    unspecified: false,
  },
  acknowledgedEmployee: {
    receivedDate: undefined,
    notSignedYet: false,
  },
};

export default schema;